import { useEffect, useState } from "react";

export const DotAnimation = () => {
    const [dots, setDots] = useState("...");

    useEffect(() => {
        const _interval = setInterval(() => {
            setDots((dots) => {
                if (dots === "") return ".";
                if (dots === ".") return "..";
                if (dots === "..") return "...";
                return "";
            });
        }, 500);

        return () => _interval && clearInterval(_interval);
    }, []);

    return (
        <div className="w-full h-full flex items-center justify-center">
            <span className="whitespace-nowrap w-3 -left-1">{dots}</span>
        </div>
    );
};
